<nav aria-label="breadcrumb" id="idBreadcrumb">
  <ol class="breadcrumb mb-0 pl-0">
    <li class="breadcrumb-item"><a  (click)="volverInicio();">Configuración de ponderaciones individuales</a>
    </li>
    <li class="breadcrumb-item active" aria-current="page"><a><strong>Crear</strong></a></li>
  </ol>
</nav>
<div class="row align-items-center">
  <a (click)="volverInicio();">
    <button class="boton_volver" data-toggle="tooltip" data-placement="top" title="VOLVER" alt="VOLVER">
      <i class="bi bi-chevron-left mr-2"></i>
      Volver
    </button>
  </a>
  <h1 class="centrar_contenido offset-4">Crear configuración</h1>

</div>
<div>
  <div *ngIf="textoError" class="alert alert-danger tipografía_alertas mt-4 mb-4" role="alert">
    <i class="bi bi bi-x-circle tamanio_iconos-boton mr-2"></i>
    {{ textoError }}
  </div>
</div>

<!-- ALCANCE DE LA CONFIGURACIÓN -->
<div class="row mt-5 align-items-center">
  <div class="hr-amarillo mr-3"></div>
  <h6 class="mb-0">Alcance de la configuración</h6>
</div>
<div class="row mt-5 align-items-end">
  <div class="col-2">
    <label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
    <label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
    <select disabled [(ngModel)]="filtroAnhoSeleccionado" (change)="seleccionFiltro('anho')" class="form-control select_criterios">
      <option [value]="null">Seleccionar</option>
      <option *ngFor="let anho of filtroAnhos">{{anho}}</option>
    </select>
  </div>
  <div class="col-2">
    <label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
    <label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
    <select disabled [(ngModel)]="filtroPeriodoSeleccionado" (change)="seleccionFiltro('periodo')" class="form-control select_criterios">
      <option [value]="null">Seleccionar</option>
			<option [value]="periodo.periodoAcademicoId" *ngFor="let periodo of filtroPeriodos">{{periodo.periodoDescripcion}}</option>
    </select>
  </div>
  <div class="col-3">
    <label class="titulo_criterios" for="exampleFormControlSelect2">Sigla asignatura</label>
    <label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
    <select disabled [(ngModel)]="filtroAsignaturaSeleccionado" (change)="seleccionFiltro('asignatura')" class="form-control select_criterios">
      <option [value]="null">Seleccionar</option>
			<option [value]="asignatura.id" *ngFor="let asignatura of filtroAsignaturas">{{asignatura.codigo}}</option>
    </select>
  </div>
  <div class="col-5">
    <label class="titulo_criterios" for="exampleFormControlSelect2">Sede</label>
    <select [(ngModel)]="filtroSedeSeleccionado" (change)="seleccionFiltro('sede')" class="form-control select_criterios">
			<option [value]='-1'>Seleccionar</option>
			<option [value]="sede.sedeId" *ngFor="let sede of filtroSedes">{{sede.descripcion}}</option>
		</select>
  </div>
</div>
<div class="row mt-3">
  <div class="col-4">
    <label class="titulo_criterios" for="exampleFormControlSelect2">Sección</label>
    <select [(ngModel)]="filtroSeccionSeleccionado" (change)="seleccionFiltro()" class="form-control select_criterios">
			<option [value]="null">Seleccionar</option>
			<option [value]="seccion.id" *ngFor="let seccion of filtroSecciones">{{seccion.descSeccion}}</option>
		</select>
  </div>
</div>
<!-- FIN ALCANCE DE LA CONFIGURACIÓN -->

<!-- DETALLE CONFIGURACIÓN -->
<div class="row mt-5 align-items-center">
  <div class="cuadrado-amarillo mr-3"></div><label class="detalle_configuracion mb-0">DETALLE
    CONFIGURACIÓN</label>
</div>


<!-- CALIFICACIONES PARCIALES -->
<div class="borde_cuadrado-negro mt-5">
  <div class="row justify-content-center">
    <div class="col-10 pl-0 mt-5">
      <label class="titulo_tipo_configuraciones">CALIFICACIONES PARCIALES</label>
    </div>
  </div>
  <div class="row justify-content-center mt-2 mb-4">
    <div class="col-10 pl-0">
      <span>Cantidad mínima de calificaciones:
        <label class="valores_configuracion ml-3">{{ minParciales }}</label>
      </span>
      <label class="hr-negro mx-4">|</label>
      <span class="mr-3">Cantidad final de calificaciones:</span>
      <button
        [disabled]="calificacionesParciales.length == 1"
        class="boton-menos valores_configuracion mx-2"
        [ngClass]="calificacionesParciales.length == 1 ? 'disabled-button' : ''"
        (click)="quitarCalif('calificacionesParciales')">
        <i class="bi bi-dash"></i>
      </button>

      <input
        [value]="calificacionesParciales.length"
        class="ancho_input mx-4 valores_configuracion"
        placeholder="0"
        type="number"
        (keyup)="ingresoCajasPonderaciones('calificacionesParciales')"
        [(ngModel)]="cantidadCajasParciales"
        max="20"
        min="1"
      >

      <button [disabled]="calificacionesParciales.length >= maxParciales" class="boton-mas valores_configuracion"
        [ngClass]="calificacionesParciales.length >= maxParciales ? 'disabled-button' : ''"
        (click)="agregarCalif('calificacionesParciales')">
        <i class="bi bi-plus"></i>
      </button>
      <label class="hr-negro mx-4">|</label>
      <span>% Total:</span>
      <label class="valores_configuracion mx-3">{{ totalParciales() }}</label>
      <i *ngIf="totalParciales() != 100" class="bi bi-exclamation-triangle tamanio_iconos-boton color_triangulo"></i>
    </div>
  </div>
  <div class="row mt-4 mb-5 offset-1">
    <div class="col-2 mb-3 borde_cuadrado-negro altura_caja_secundaria mr-3 centrar_contenido"
      *ngFor="let calificacion of calificacionesParciales; index as i" min="1" max="20">
      <p class="mb-0">% Calif. {{ i + 1 }}:
        <input class="ancho_input" type="number" [(ngModel)]="calificacion.porcentaje" min="0" max="100" maxlength="3">
      </p>
    </div>
  </div>
</div>
<!-- FIN CALIFICACIONES PARCIALES -->

<!-- EXAMEN -->
<div class="cuadrado_gris mt-5">
  <div class="row justify-content-center">
    <div class="col-10 pl-0 mt-5">
      <label class="titulo_tipo_configuraciones">EXAMEN</label>
    </div>
  </div>
  <div class="row justify-content-center mt-2 mb-4">
    <div class="col-10 pl-0">

      <span>Cantidad mínima de exámenes: </span>
      <label class="valores_configuracion ml-3">{{ minExamenes }}</label>

      <label class="hr-negro mx-4">|</label>

      <span class="mr-4">Cantidad final de exámenes:</span>
      <button
        class="boton-menos valores_configuracion mx-2"
        [disabled]="calificacionesExamenes.length == 0"
        (click)="quitarCalif('calificacionesExamenes')"
        [ngClass]="calificacionesExamenes.length == 0 ? 'disabled-button' : ''">
        <i class="bi bi-dash"></i>
      </button>
      <input
      type="number"
      [value]="calificacionesExamenes.length"
      class="ancho_input mx-4 valores_configuracion"
      (keyup)="ingresoCajasPonderaciones('calificacionesExamenes')"
      [(ngModel)]="cantidadCajasExamenes"
      onkeypress="return event.charCode >= 48"
      min="0"
      max="2"
      >

      <button class="boton-mas valores_configuracion" [disabled]="calificacionesExamenes.length >= maxExamenes"
        (click)="agregarCalif('calificacionesExamenes')"
        [ngClass]="calificacionesExamenes.length >= maxExamenes ? 'disabled-button' : ''">
        <i class="bi bi-plus"></i>
      </button>
      <label class="hr-negro mx-4">|</label>
      <span>% Total:
        <label *ngIf="calificacionesExamenes.length != 0" class="valores_configuracion ml-3">
          {{ totalExamenes() }}
        </label>
        <i *ngIf="totalExamenes() != 100 && calificacionesExamenes.length != 0" class="bi bi-exclamation-triangle ml-2 tamanio_iconos-boton color_triangulo" data-toggle="tooltip" data-placement="top" alt="test"></i>
        <i *ngIf="calificacionesExamenes.length<=0" class="bi bi-dash ml-2 tamanio_iconos-boton" data-toggle="tooltip" data-placement="top" alt="test"></i>
      </span>
    </div>
  </div>

  <div class="row mt-4 mb-5 mr-5 offset-1">
    <div class="col-2 borde_cuadrado-negro altura_caja_secundaria mr-3 centrar_contenido" *ngFor="let calificacionEx of calificacionesExamenes; index as i">
      <p class="mb-0">% Calif. {{ i + 1 }}:
        <input class="ancho_input" type="number" [(ngModel)]="calificacionEx.porcentajeE">
      </p>
    </div>
  </div>
  <div class="row mb-5" *ngIf="calificacionesExamenes.length>0">
    <div class="col-4 offset-1 pl-0 d-flex align-items-flex-start mt-5" >
      <span class="mr-5">Activar examen extraordinario</span>
      <label class="switch">
        <input type="checkbox" (click)="switchExamenExtraordinario()" [checked]="activarExamenExtraordinario">
        <span class="slider round"></span>
      </label>
      <span class="pl-4">{{ activarExamenExtraordinario ? 'Si' : 'No' }}</span>
    </div>
    <ng-container *ngIf="activarExamenExtraordinario">
      <div class="col-2 borde_cuadrado-negro altura_caja_secundaria mr-3 centrar_contenido" *ngFor="let calificacionEx of calificacionesExamenes; index as i">
        <p class="mb-0">% Calif. {{ i + 1 }}:
          <input class="ancho_input" type="number" [(ngModel)]="calificacionEx.porcentajeE" disabled>
        </p>
      </div>
    </ng-container>
  </div>
</div>
<!-- FIN EXAMEN -->

<!-- PONDERACIÓN PROMEDIOS -->
<div class="borde_cuadrado-negro mt-5 mb-5">
  <div class="row justify-content-center">
    <div class="col-10 pl-0 mt-5">
      <label class="titulo_tipo_configuraciones">PONDERACIÓN PROMEDIOS</label>
    </div>
  </div>
  <div class="row justify-content-center mt-2 mb-5">
    <div class="col-10 pl-0">
      <span>% Promedio final (PCP):
        <label class="valores_configuracion mx-4">
          <input class="ancho_input" type="number" placeholder="0" [(ngModel)]="ponderacionPCP">
        </label>
      </span>
      <label class="hr-negro mx-4">|</label>
      <span>% Promedio examen (PCET):
        <label class="valores_configuracion mx-4">
          <input [disabled]="calificacionesExamenes.length<=0" class="ancho_input" type="number" placeholder="0" [(ngModel)]="ponderacionPCET">
        </label>
      </span>
      <label class="hr-negro mx-4">|</label>
      <span>% Total:
        <label class="valores_configuracion ml-3">
          {{ totalPonderacionPromedio() }}
        </label>
        <i *ngIf="totalPonderacionPromedio() != 100 || (calificacionesExamenes.length > 0 && ponderacionPCET === 0)" class="bi bi-exclamation-triangle ml-2 tamanio_iconos-boton color_triangulo"></i>
      </span>
    </div>
  </div>
</div>
<!-- FIN PONDERACIÓN PROMEDIOS -->

<!-- FIN DETALLE CONFIGURACIÓN -->

<div class="row justify-content-center mb-5 mt-5">
  <a (click)="volverInicio()">
    <button class="boton-secundario my-5" data-toggle="tooltip" data-placement="top" title="CANCELAR" alt="CANCELAR">
      cancelar
    </button>
  </a>

  <button (click)="validarNotasIngresadas()" class="boton-primario tamanio_minimo ml-3 my-5" data-toggle="tooltip" data-placement="top" title="CREAR" alt="CREAR">
    crear
  </button>
</div>

<app-modal-info modalId="modal-info" [titulo]="infoModalTitulo" [texto]="infoModalTexto"></app-modal-info>
<button id="btn-modal-info" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-info">
  Launch demo modal
</button>

<!-- Modal confirmar validaPonderacion -->
<button id="btn-modal-confirmar" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modalConfirmar">
  Launch demo modal
</button>
<div class="modal fade" id="modalConfirmar" tabindex="-1" role="dialog" aria-labelledby="modalConfirmar"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Atención</h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
          <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
        </button>
      </div>
      <div class="modal-body">
          <div class="row align-items-center my-3 mx-4">
            <p class="mb-4 ml-3" [innerHtml]="textoValidarPonderacion"></p>
          </div>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="boton-secundario boton_secundario_modal ml-3 my-2" (click)="crearPonderacionIndividual()" data-dismiss="modal">
          Si
        </button>
        <button type="button" class="btn boton-primario my-2" data-dismiss="modal">
          No
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-ponderacion-notas-previas (cstmFn)="validarPonderacion()"></app-modal-ponderacion-notas-previas>